import { PageFooter } from '../../Common/Footer'
import styles from './Footer.css'

const Footer = () => {
  return (
    <PageFooter
      className={styles.footer}
    />
  )
}

export default Footer
